import { User } from "../api/interface/user.interface";

export const hasAnyRole = (
  user: User | null,
  roles: string[]
): boolean =>
  user?.roles?.some(r => roles.includes(r.name)) ?? false;

export const hasAllRoles = (
  user: User | null,
  roles: string[]
): boolean =>
  roles.every(role =>
    user?.roles?.some(r => r.name === role)
  );